import { Input, InputProps } from "../Input";

import { InputMode } from "Components/Form/Input/inputTypes";
import { formatNin } from "Formatting/formatNin";
import React from "react";

export const NinInput = (
  props: Omit<InputProps, "inputMode">,
): React.ReactElement => {
  return (
    <Input
      {...props}
      inputProps={{ ...props.inputProps, maxLength: 12 }}
      inputMode={InputMode.NUMERIC}
      onChange={(e) => {
        e.target.value = formatNin(e.target.value);
      }}
    />
  );
};
